export default __webpack_public_path__ + "static/media/calendar-next.54b83a0f.svg";